<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M26.04 5.96a1 1 0 010 1.414L9.08 24.334H20a1 1 0 010 2H6.667a1 1 0 01-1-1V12a1 1 0 112 0v10.92l16.96-16.96a1 1 0 011.413 0z"/></svg>